module.exports = __webpack_public_path__ + "static/img/félouque.56205a1.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/félouque.png
// module id = sGvC
// module chunks = 1